import React from 'react';
import { TextArea } from '@common/components/textarea';
import { Form } from 'antd';

export const CommentInput = ({
  label = 'Comment',
  required = false,
  commentMaxLength = 500,
  placeholder = '',
}: {
  label?: string;
  required?: boolean;
  commentMaxLength?: number;
  placeholder: string;
}) => (
  <Form.Item
    label={label}
    name={['commentContent', 'contentAsText']}
    rules={[
      {
        required: required,
        message: `${label} is required.`,
        type: 'string',
      },
    ]}
  >
    <TextArea maxLength={commentMaxLength} placeholder={placeholder} />
  </Form.Item>
);
